import { Direction } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text, useTooltip } from '@frontend/design-system';

type GroupNotDeliveredStatusProps = {
  failedRecipientNames: string[];
  totalRecipients: number;
  direction: Direction;
};

export const GroupNotDeliveredStatus = ({
  failedRecipientNames,
  totalRecipients,
  direction,
}: GroupNotDeliveredStatusProps) => {
  const { t } = useTranslation('thread-body');
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({
    placement: direction === Direction.DIRECTION_INBOUND ? 'top-end' : 'top-start',
    trigger: 'hover',
  });

  return (
    <>
      <span
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(0.5),
        }}
        {...triggerProps}
      >
        <Icon name='alert-invert-small' color='error' />
        <Text color='error' size='small'>
          {t('Not delivered to {{failed}} of {{total}}', {
            failed: failedRecipientNames.length,
            total: totalRecipients,
          })}
        </Text>
      </span>
      <Tooltip {...tooltipProps}>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(0.25),
            textAlign: 'left',
          }}
        >
          <span css={{ fontWeight: theme.font.weight.bold }}>{t('Not delivered to:')}</span>
          {failedRecipientNames.map((name, index) => (
            <span key={`${name}-${index}`}>{name}</span>
          ))}
        </div>
      </Tooltip>
    </>
  );
};
